import { useState } from 'react';
import { useRecoverXpressIdAccessData } from 'components/VideoSelfieRecovery/VideoSelfie/hooks/useRecoverXpressIdAccessData';
import { getStatusCodeFromErrorCode } from 'utilities/video/status/getStatusCodeFromErrorCode';
import { getStatusCodeFromErrorEventCode } from 'utilities/video/status/getStatusCodeFromErrorEventCode';
import { getStatusCodeFromInfoEventCode } from 'utilities/video/status/getStatusCodeFromInfoEventCode';

export const useVideoSelfieCapture = ({ clientId, token }) => {
    const [showCompletedMessage, setShowCompletedMessage] = useState(false);
    const [videoSelfieError, setVideoSelfieError] = useState(null);

    const { accessToken, documentType } = useRecoverXpressIdAccessData({ clientId, token }, ({ errorCode }) => {
        const statusCode = getStatusCodeFromErrorCode(errorCode);
        setVideoSelfieError({ statusCode, code: errorCode });
    });

    const handleProcessCompleted = () => setShowCompletedMessage(true);

    const handleProcessError = ({ code }) => {
        const statusCode = getStatusCodeFromErrorEventCode(code);
        setVideoSelfieError({ statusCode, code });
    };

    const handleProcessEvents = ({ infoEvent }) => {
        const { code } = infoEvent;
        const statusCode = getStatusCodeFromInfoEventCode(code);
        if (statusCode) setVideoSelfieError({ statusCode, code });
    };

    return {
        accessToken,
        documentType,
        showCompletedMessage,
        videoSelfieError,
        handleProcessError,
        handleProcessEvents,
        handleProcessCompleted,
    };
};
